import { Timetable } from './../models/employee';
import { EmployeeServices } from './employee.services';
import { BaseServices } from './../../kuba.services';
import { Injectable } from '@angular/core';

@Injectable()
export class TimeTableListResolver {
  constructor(private backend: EmployeeServices) { }
  resolve() {
    return this.backend.getAllTimetableByBusinessId(BaseServices.BusinessId);
  }
}
